import { Filter } from '@api/user/types/Filter';
import { FullFilter } from '@api/user/types/FullFilter';
import { initialState } from '@pages/filter/store/slice';
import { formatISO } from 'date-fns';



export const convertFullFilterToFilter = (fullFilter: FullFilter | null | undefined): Filter => {
	if (!fullFilter) return initialState.modifiedFilter;

	return ({
		dateFrom: formatISO(new Date()),
		dateTo: formatISO(new Date()),
		distributionTypes: fullFilter.distributionTypes.map(x => x.id),
		orderTypes: fullFilter.orderTypes.map(x => x.id),
		countries: fullFilter.countries.map(x => x.id),
		regions: fullFilter.regions.map(x => x.id),
		distributionRegions: fullFilter.distributionRegions.map(x => x.id),
		districts: fullFilter.districts.map(x => x.id),
		distributionDistricts: fullFilter.distributionDistricts.map(x => x.id),
		executionPlaces: fullFilter.executionPlaces.map(x => x.id),
		customerHierarchies: fullFilter.customerHierarchies.map(x => x.id),
		materialTypes: fullFilter.materialTypes.map(x => x.id),
		onOffTrade: fullFilter.onOffTrade.map(x => x.id),
	});
}